/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import IconButton from "@material-ui/core/IconButton";
import Swal from "sweetalert2";
import BuscaForm from "../../gww-lib/busca-no-form/index";
import somenteDecimal from "../../../tools/somenteDecimal";
import mascaraPreco from "../../../tools/mascaras/real";
import apresentarDecimal from "../../../tools/apresentarDecimal";
import consultaApi from "../../../services/consultaApi";
import Grid from "@material-ui/core/Grid";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import validaString from "../../../tools/validaString";

const useStyles = makeStyles((theme) => ({
  controlaTitulo: {
    fontSize: "1.5em",
  },
  botaoRodape: {
    padding: theme.spacing(1),
  },
  controlaAddItem: {
    margin: "0px 0px 5px 0px",
  },
  textField: {
    marginBottom: 8,
  },
  containerzindex: {
    zIndex: 100000,
  },
}));

export default function FormItensNfe(props) {
  const {
    adicionarItem,
    grid,
    produtoNfe,
    indexProduto,
    inativo,
    cfopPai,
    descricaoCfopPai,
  } = props;

  const classes = useStyles();

  const [codigoItem, setCodigoItem] = useState(
    produtoNfe ? produtoNfe.codigoItem : 0
  );
  const [produto, setProduto] = useState(produtoNfe ? produtoNfe.produto : "");

  const [descricaoProduto, setDescricaoProduto] = useState(
    produtoNfe ? produtoNfe.descricaoProduto : ""
  );
  const [produtoErro, setProdutoErro] = useState(false);
  const [produtoErroTexto, setProdutoErroTexto] = useState();

  const [descricaoDetalhada, setDescricaoDetalhada] = useState(
    produtoNfe ? produtoNfe.descricaoDetalhada : ""
  );

  const [quantidade, setQuantidade] = useState(
    produtoNfe ? produtoNfe.quantidade : ""
  );
  const [quantidadeErro, setQuantidadeErro] = useState(false);
  const [quantidadeErroTexto, setQuantidadeErroTexto] = useState();

  const [preco, setPreco] = useState(
    produtoNfe ? apresentarDecimal(produtoNfe.preco) : ""
  );
  const [precoErro, setPrecoErro] = useState(false);
  const [precoErroTexto, setPrecoErroTexto] = useState();

  const [desconto, setDesconto] = useState(
    produtoNfe ? apresentarDecimal(produtoNfe.desconto) : ""
  );
  const [descontoErro] = useState(false);
  const [descontoErroTexto] = useState();

  const [grupoImposto, setGrupoImposto] = useState(
    produtoNfe ? produtoNfe.grupoImposto : ""
  );
  const [descricaoGrupoImposto, setDescricaoGrupoImposto] = useState(
    produtoNfe ? produtoNfe.descricaoGrupoImpsto : ""
  );
  const [grupoImpostoErro, setGrupoImpostoErro] = useState(false);
  const [grupoImpostoErroTexto, setGrupoImpostoErroTexto] = useState();

  const [cfop, setCfop] = useState(produtoNfe ? produtoNfe.cfop : "");
  const [descricaoCfop, setDescricaoCfop] = useState(
    produtoNfe ? produtoNfe.descricaoCfop : ""
  );
  const [cfopErro, setCfopErro] = useState(false);
  const [cfopErroTexto, setCfopErroTexto] = useState();

  const [frete, setFrete] = useState(
    produtoNfe ? apresentarDecimal(produtoNfe.frete) : ""
  );
  const [freteErro] = useState(false);
  const [freteErroTexto] = useState();

  const [seguro, setSeguro] = useState(
    produtoNfe ? apresentarDecimal(produtoNfe.seguro) : ""
  );
  const [seguroErro] = useState(false);
  const [seguroErroTexto] = useState();

  const [outros, setOutros] = useState(
    produtoNfe ? apresentarDecimal(produtoNfe.outros) : ""
  );
  const [outrosErro] = useState(false);
  const [outrosErroTexto] = useState();

  const [bloqueiaSalvar, setBloqueiaSalvar] = useState(false);

  const produtoAnterior = useRef();

  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    produtoAnterior.current = descricaoProduto;
    if (produtoNfe) {
      return;
    }
    if (open) {
      setBloqueiaSalvar(false);
      setCodigoItem(0);
      setProduto("");
      setDescricaoProduto("");
      setQuantidade("");
      setDescricaoDetalhada("");
      setPreco("");
      setDesconto("");
      setGrupoImposto("");
      setDescricaoGrupoImposto("");
      setCfop("");
      setDescricaoCfop("");
      setFrete("");
      setSeguro("");
      setOutros("");
    } else {
      setBloqueiaSalvar(true);
    }
  }, [open]);

  useEffect(() => {
    async function buscarDadosProduto() {
      let dadosEnvio = {
        PROCNAME: "WEBSITE_GPMS_BYID",
        PCCDPMS: produto,
      };

      const resposta = await consultaApi(dadosEnvio);

      if (resposta.data.DATASET) {
        if (grupoImposto == "" || produtoAnterior.current != descricaoProduto) {
          setGrupoImposto(resposta.data.DATASET[0].CCDTAXGRUPO);
          setDescricaoGrupoImposto(resposta.data.DATASET[0].CDSTAXGRUPO);
        }

        if (localStorage.getItem("APRESENTA_DESCRICAO_DETALHADA") != "0") {
          if (
            descricaoDetalhada == "" || produtoAnterior.current != descricaoProduto
          ) {
            setDescricaoDetalhada(resposta.data.DATASET[0].CMSGNFPROD);
          }
        }


        if (cfop == "" || produtoAnterior.current != descricaoProduto) {
          if (
            resposta.data.DATASET[0].PCCDCFOP.toString().substring(0, 1) ===
            cfopPai.toString().substring(0, 1)
          ) {
            setCfop(resposta.data.DATASET[0].PCCDCFOP);
            setDescricaoCfop(resposta.data.DATASET[0].CDSCFOP);
          } else {
            let cfopEquivalente =
              cfopPai.toString().substring(0, 1) +
              resposta.data.DATASET[0].PCCDCFOP.toString().substring(1, 4);

            if (cfopEquivalente === cfopPai) {
              setCfop(cfopEquivalente);
              setDescricaoCfop(descricaoCfopPai);
            } else {
              setCfop(resposta.data.DATASET[0].PCCDCFOP);
              setDescricaoCfop(resposta.data.DATASET[0].CDSCFOP);
              setCfopErro(true);
              setCfopErroTexto("CFOP incompativel com o estado do cliente.");
            }
          }
        }

        if (preco == "" || produtoAnterior.current != descricaoProduto) {
          setPreco(apresentarDecimal(resposta.data.DATASET[0].NVLPROD));
        }
      }
      produtoAnterior.current = descricaoProduto;
    }

    if (produto != undefined || produto > 0) {
      buscarDadosProduto();
    }
  }, [descricaoProduto]);

  async function validaCampos() {
    let camposErrados = [];

    if (produto === "") {
      setProdutoErro(true);
      setProdutoErroTexto(`Campo obrigatorio, Por favor preencha`);
      camposErrados.push("Produto");
    } else {
      if (descricaoProduto === "") {
        setProdutoErro(true);
        setProdutoErroTexto("Informe um Produto Valido, use a pesquisa.");
        camposErrados.push("Produto");
      } else {
        setProdutoErro(false);
      }
    }

    if (quantidade === "") {
      setQuantidadeErro(true);
      setQuantidadeErroTexto(
        "Campo Obrigatorio. Por favor preencha a descrição."
      );
      camposErrados.push("Quantidade");
    } else {
      setQuantidadeErro(false);
    }

    if (preco === "") {
      setPrecoErro(true);
      setPrecoErroTexto("Campo Obrigatorio. Por favor preencha a descrição.");
      camposErrados.push("Preço");
    } else {
      if (somenteDecimal(preco) == 0) {
        setPrecoErro(true);
        setPrecoErroTexto("Informe um valor maior que ZERO");
        camposErrados.push("Preço");
      } else {
        setPrecoErro(false);
      }
    }

    if (grupoImposto === "") {
      setGrupoImpostoErro(true);
      setGrupoImpostoErroTexto(`Campo obrigatorio, Por favor preencha`);
      camposErrados.push("Grupo de Imposto");
    } else {
      if (descricaoGrupoImposto === "") {
        setGrupoImpostoErro(true);
        setGrupoImpostoErroTexto(
          "Informe um Grupo de Imposto Valido, use a pesquisa."
        );
        camposErrados.push("Grupo de Imposto");
      } else {
        setGrupoImpostoErro(false);
      }
    }

    if (cfop === "") {
      setCfopErro(true);
      setCfopErroTexto(`Campo obrigatorio, Por favor preencha`);
      camposErrados.push("CFOP");
    } else {
      if (descricaoCfop === "") {
        setCfopErro(true);
        setCfopErroTexto("Informe uma CFOP, use a pesquisa.");
        camposErrados.push("CFOP");
      } else {
        setCfopErro(false);
      }
    }

    if (camposErrados.length === 0) {
      let estadoCfop = cfop.toString().substring(0, 1);
      let estadoCfopPai = cfopPai.toString().substring(0, 1);
      let cfopEquivalente;
      if (estadoCfop !== estadoCfopPai) {
        cfopEquivalente = estadoCfopPai + cfop.toString().substring(1, 4);

        let dadosValidacaoCfop = {
          PROCNAME: "WEBSITE_TCFOP_DESCBYID",
          ID: cfopEquivalente,
        };
        const retornoValidacaoCfop = await consultaApi(dadosValidacaoCfop);

        if (retornoValidacaoCfop.data.DATASET) {
          await Swal.fire({
            title: "CFOP informado incompativel",
            html: `<p>O CFOP ${cfop} é para vendas para clientes de ${estadoCfop === "5" ? `dentro do estado` : `outro estado`
              }.</p>
                      <p>O CFOP ${cfopEquivalente} seria o equivalente para ${estadoCfop === "5" ? `outro estado` : `dentro do estado`
              }.</p>
                      <p>Deseja fazer a alteração ?<p/>`,
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonText: `Sim`,
            cancelButtonText: `Não`,
            customClass: {
              container: classes.containerzindex,
            },
          }).then((result) => {
            if (result.value) {
              setCfop(cfopEquivalente);
              return true;
            } else {
              setCfopErro(true);
              setCfopErroTexto("Por favor preencha o Cfop,campo obrigatorio");
              return false;
            }
          });
        } else {
          Swal.fire({
            type: "error",
            title: `CFOP invalido para venda ${estadoCfopPai === "5" ? "dentro do estado" : "fora do estado"
              }.`,
            customClass: {
              container: classes.containerzindex,
            },
          });
          return false;
        }
      }
    }

    if (camposErrados.length === 0) {
      return true;
    } else {
      return false;
    }
  }

  async function salvar() {
    if (await validaCampos()) {
      if (produtoNfe) {
        setBloqueiaSalvar(false);
      } else {
        setBloqueiaSalvar(true);
      }
      adicionarItem(
        {
          codigoItem,
          produto,
          descricaoProduto,
          descricaoDetalhada,
          quantidade,
          preco: somenteDecimal(preco),
          desconto: desconto === "" ? 0 : somenteDecimal(desconto),
          grupoImposto,
          descricaoGrupoImposto,
          cfop,
          descricaoCfop,
          frete: frete === "" ? 0 : somenteDecimal(frete),
          seguro: seguro === "" ? 0 : somenteDecimal(seguro),
          outros: outros === "" ? 0 : somenteDecimal(outros),
        },
        indexProduto
      );

      setOpen(false);

      const Toast = Swal.mixin({
        toast: true,
        position: "top-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        type: "success",
        title: "Produto Salvo",
      });
    }
  }

  function cancelar() {
    setOpen(false);
  }

  const handleOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      {grid ? (
        <IconButton aria-label="alterar" onClick={(e) => handleOpen(e)}>
          {inativo ? <VisibilityIcon /> : <EditRoundedIcon />}
        </IconButton>
      ) : (
          <Button
            type="button"
            color="secondary"
            variant="contained"
            className={classes.controlaAddItem}
            fullWidth
            startIcon={<AddCircleOutlineOutlinedIcon />}
            onClick={handleOpen}
            disabled={inativo}
          >
            Adicionar Item
          </Button>
        )}
      <Dialog
        open={open}
        onClose={handleClose}
        fullScreen
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogContent dividers="true">
          <form>
            <BuscaForm
              codigo={produto}
              tabela="PRODUTO"
              label="Produto"
              consultaInstantanea
              setCodigoPai={(produto) => setProduto(produto)}
              setDescricao={(descricao) => setDescricaoProduto(descricao)}
              descricao={descricaoProduto}
              procedureConsulta="WEBSITE_LISTAGEM_GPMS_ATIVO"
              filtro="CDSPMS"
              erroTexto={produtoErroTexto}
              erro={produtoErro}
              inativo={inativo}
            />

            {localStorage.getItem("APRESENTA_DESCRICAO_DETALHADA") != "0" && (
              <TextField
                className={classes.textField}
                label="Descricao Detalhada"
                variant="outlined"
                disabled={inativo}
                multiline
                rows={4}
                fullWidth
                value={descricaoDetalhada}
                onChange={(e) =>
                  validaString(setDescricaoDetalhada, 400, e.target.value)
                }
              />
            )}

            <TextField
              className={classes.textField}
              label="Quantidade"
              type="number"
              error={quantidadeErro}
              helperText={quantidadeErroTexto}
              variant="outlined"
              fullWidth
              value={quantidade}
              onChange={(e) => setQuantidade(e.target.value)}
              disabled={inativo}
            />

            <TextField
              className={classes.textField}
              label="Preço Unitario"
              error={precoErro}
              helperText={precoErroTexto}
              variant="outlined"
              fullWidth
              value={preco}
              onChange={(e) => setPreco(e.target.value)}
              disabled={inativo}
              InputProps={{
                inputComponent: mascaraPreco,
              }}
            />

            <TextField
              className={classes.textField}
              label="Valor Desconto"
              error={descontoErro}
              helperText={descontoErroTexto}
              variant="outlined"
              fullWidth
              value={desconto}
              onChange={(e) => setDesconto(e.target.value)}
              disabled={inativo}
              InputProps={{
                inputComponent: mascaraPreco,
              }}
            />

            <BuscaForm
              codigo={grupoImposto}
              tabela="GRUPO_IMPOSTO"
              label="Grupo De Imposto"
              consultaInstantanea
              setCodigoPai={setGrupoImposto}
              setDescricao={setDescricaoGrupoImposto}
              descricao={descricaoGrupoImposto}
              procedureConsulta="WEBSITE_LISTAGEM_IMP_GRUPO"
              filtro="CDSTAXGRUPO"
              erroTexto={grupoImpostoErroTexto}
              erro={grupoImpostoErro}
              inativo={inativo}
            />

            <BuscaForm
              codigo={cfop}
              tabela="CFOP"
              label="CFOP"
              setCodigoPai={(cfop) => setCfop(cfop)}
              setDescricao={setDescricaoCfop}
              descricao={descricaoCfop}
              procedureConsulta="WEBSITE_LISTAGEM_TCFOP"
              filtro="CDSCFOP"
              erroTexto={cfopErroTexto}
              erro={cfopErro}
              inativo={inativo}
            />

            <TextField
              label="Valor de Frete"
              className={classes.textField}
              error={freteErro}
              helperText={freteErroTexto}
              variant="outlined"
              fullWidth
              value={frete}
              onChange={(e) => setFrete(e.target.value)}
              disabled={inativo}
              InputProps={{
                inputComponent: mascaraPreco,
              }}
            />

            <TextField
              label="Valor de Seguro"
              className={classes.textField}
              error={seguroErro}
              helperText={seguroErroTexto}
              variant="outlined"
              fullWidth
              value={seguro}
              onChange={(e) => setSeguro(e.target.value)}
              disabled={inativo}
              InputProps={{
                inputComponent: mascaraPreco,
              }}
            />

            <TextField
              label="Valor de outros"
              className={classes.textField}
              error={outrosErro}
              helperText={outrosErroTexto}
              variant="outlined"
              fullWidth
              value={outros}
              onChange={(e) => setOutros(e.target.value)}
              disabled={inativo}
              InputProps={{
                inputComponent: mascaraPreco,
              }}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Grid container>
            {inativo ? (
              <Grid item xs={12} className={classes.botaoRodape}>
                <Button
                  variant="contained"
                  color="secondary"
                  type="button"
                  onClick={cancelar}
                  fullWidth
                >
                  Sair
                </Button>
              </Grid>
            ) : (
                <>
                  <Grid item xs={6} className={classes.botaoRodape}>
                    <Button
                      variant="contained"
                      color="secondary"
                      type="button"
                      onClick={cancelar}
                      fullWidth
                    >
                      Cancelar
                  </Button>
                  </Grid>
                  <Grid item xs={6} className={classes.botaoRodape}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={bloqueiaSalvar}
                      onClick={salvar}
                      fullWidth
                    >
                      Salvar
                  </Button>
                  </Grid>
                </>
              )}
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}
